import { produce } from 'immer'
import AccountBudgetsReducer, {
  AccountBudgetsState,
  Actions as AccountBudgetsActions,
  initialState as initialAccountBudgetsState,
} from 'src/app/AccountBudgets/redux/accountBudgets.reducer'
import AccountOverviewReducer, {
  AccountOverviewState,
  Actions as AccountOverviewActions,
  initialState as initialAccountOverviewState,
} from 'src/app/AccountOverview/redux/accountOverview.reducer'
import AccountSettingsReducer, {
  AccountSettingsState,
  Actions as AccountSettingsActions,
  initialState as initialAccountSettingsState,
} from 'src/app/AccountSettings/redux/accountSettings.reducer'
import AccountTransactionsReducer, {
  AccountTransactionsState,
  Actions as AccountTransactionsActions,
  initialState as initialAccountTransactionsState,
} from 'src/app/AccountTransactions/redux/accountTransactions.reducer'
import AccountVirtualCardsReducer, {
  AccountVirtualCardsState,
  Actions as AccountVirtualCardsActions,
  initialState as initialAccountVirtualCardsState,
} from 'src/app/AccountVirtualCards/redux/accountVirtualCards.reducer'
import {
  GET_CREDIT_CARD_FAILURE,
  GET_CREDIT_CARD_INIT,
  GET_CREDIT_CARD_SUCCESS,
  GET_PARENT_CREDIT_CARD_FAILURE,
  GET_PARENT_CREDIT_CARD_INIT,
  GET_PARENT_CREDIT_CARD_SUCCESS,
  GetCreditCardActions,
  GetParentCreditCardActions,
} from 'src/redux/actions/data/creditCards.actions'

export interface AccountBaseState {
  fetchingCreditCard: boolean
  fetchingParentCreditCard: boolean
}
export const initialBaseState: AccountBaseState = {
  fetchingCreditCard: false,
  fetchingParentCreditCard: false,
}

export type BaseActions = GetCreditCardActions | GetParentCreditCardActions

const BaseAccountReducer = (
  state = initialBaseState,
  action: BaseActions,
): AccountBaseState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_CREDIT_CARD_INIT: {
        draft.fetchingCreditCard = true
        return draft
      }

      case GET_PARENT_CREDIT_CARD_INIT: {
        draft.fetchingParentCreditCard = true
        return draft
      }

      case GET_CREDIT_CARD_SUCCESS: {
        draft.fetchingCreditCard = false
        return draft
      }

      case GET_PARENT_CREDIT_CARD_SUCCESS: {
        draft.fetchingCreditCard = false
        return draft
      }

      case GET_CREDIT_CARD_FAILURE: {
        draft.fetchingCreditCard = false
        return draft
      }

      case GET_PARENT_CREDIT_CARD_FAILURE: {
        draft.fetchingCreditCard = false
        return draft
      }
    }
  })
}

export type AccountState = AccountBaseState & {
  accountTransactions: AccountTransactionsState
  accountOverview: AccountOverviewState
  accountSettings: AccountSettingsState
  accountVirtualCards: AccountVirtualCardsState
  accountBudgets: AccountBudgetsState
}

export const initialState: AccountState = {
  ...initialBaseState,
  accountTransactions: initialAccountTransactionsState,
  accountOverview: initialAccountOverviewState,
  accountSettings: initialAccountSettingsState,
  accountVirtualCards: initialAccountVirtualCardsState,
  accountBudgets: initialAccountBudgetsState,
}

export type Actions =
  | BaseActions
  | AccountTransactionsActions
  | AccountOverviewActions
  | AccountSettingsActions
  | AccountVirtualCardsActions
  | AccountBudgetsActions

const AccountReducer = (
  state = initialState,
  action: Actions,
): AccountState => ({
  ...BaseAccountReducer(state, action as BaseActions),
  accountTransactions: AccountTransactionsReducer(
    state.accountTransactions,
    action as AccountTransactionsActions,
  ),
  accountOverview: AccountOverviewReducer(
    state.accountOverview,
    action as AccountOverviewActions,
  ),
  accountSettings: AccountSettingsReducer(
    state.accountSettings,
    action as AccountSettingsActions,
  ),
  accountVirtualCards: AccountVirtualCardsReducer(
    state.accountVirtualCards,
    action as AccountVirtualCardsActions,
  ),
  accountBudgets: AccountBudgetsReducer(
    state.accountBudgets,
    action as AccountBudgetsActions,
  ),
})

export default AccountReducer
